/**
 * <dj-tabs> — accessible tab strip for product information panels.
 *
 * Progressive enhancement: the Liquid renders every panel visible with correct
 * ARIA relationships already in place, so if this script never loads the content
 * is all still readable. On upgrade we hide the inactive panels and wire up
 * mouse + keyboard interaction per the WAI-ARIA tabs pattern.
 */
if (!customElements.get('dj-tabs')) {
  class DjTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (this.tabs.length < 2) return;

      this.setAttribute('data-enhanced', 'true');
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
      });
      this.select(0);
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      this.activeIndex = index;
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;
      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;
      event.preventDefault();
      this.select(next);
      this.tabs[next].focus();
    }
  }
  customElements.define('dj-tabs', DjTabs);
}
